<template>
    <div id="manage" :style="{width:clientW+'px'}" style="margin:0 auto">
        <div id="root" :style="{ width:clientW+'px'}">
            <!-- 全部页面的系统通知 -->
            <div v-if="$route.meta.keepAlive">
                <keep-alive>
                  <!-- <transition name="van-fade" mode="out-in"> -->
                      <router-view ></router-view>  
                  <!-- </transition> -->
              </keep-alive>
            </div>
            <div v-if="!$route.meta.keepAlive">
                <router-view ></router-view>  
            </div>
            <music-nav></music-nav>
            
        </div>
    </div>
</template>
<script>
import musicNav from '../components/music'
export default {
    data () {
        return {
            winScreenW:window.screen.width,                 // 宽度 
            winScreenH:window.screen.height,                // 高度
            clientW:document.body.clientWidth,              // 可视区高度
            clientH:document.body.clientHeight,             // 可视区高度
            screenParm:"",                                  // 屏幕参数
            imgPath:imgPath,
            
        }
    },
    created () {
      this.getViewScale();
      
    },
    methods: {
        getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        },
    },
    components:{
      musicNav
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/Manage.vue